/*                                                                           */
export const ASSORTMENTS_WITH_SPECIAL_TILE_DISPLAY = ['Bekleidung', 'Schuhe', 'Wäsche'] as const;
export const ASSORTMENTS_WITH_SPECIAL_TILE_DISPLAY_SET = new Set(
    ASSORTMENTS_WITH_SPECIAL_TILE_DISPLAY.map((item) => item.toLowerCase()),
);
